import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "../src/styles/tailwind.css"; // Import Tailwind first
import "../src/styles/index.css"; // Then your base styles
import reportWebVitals from "./utils/reportWebVitals";

// Import i18n configuration
import "./i18n/config/i18n";

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
